import sanitize from 'sanitize-html';
import bootbox from 'bootbox';

import { applyBoxCSS, ButtonsOptions, confirmButtons } from './utils';

type ConfirmCallback = (confirmed: boolean) => void;

interface ConfirmAsyncOptions {
  title: string;
  message: string;
  buttons: ButtonsOptions;
}

interface ConfirmOptions extends ConfirmAsyncOptions {
  callback: ConfirmCallback;
}

export function confirmWebEditorDiscard() {
  const options = {
    title: 'Вы уверены?',
    message: 'В редакторе есть несохраненные изменения. Покинуть страницу?',
    buttons: {
      confirm: {
        label: 'Да',
        className: 'btn-danger',
      },
    },
  };
  return new Promise((resolve) => {
    confirm({
      ...options,
      callback: (confirmed) => resolve(confirmed),
    });
  });
}

export function confirmAsync(options: ConfirmAsyncOptions) {
  return new Promise((resolve) => {
    confirm({
      ...options,
      callback: (confirmed) => resolve(confirmed),
    });
  });
}

export function confirm(options: ConfirmOptions) {
  const box = bootbox.confirm({
    title: options.title,
    message: options.message,
    buttons: confirmButtons(options.buttons),
    callback: options.callback,
  });

  applyBoxCSS(box);
}

export function confirmAccessControlUpdate(callback: ConfirmCallback) {
  confirm({
    title: 'Вы уверены?',
    message:
      'Изменение владельца ресурса может ограничить доступ к нему для части пользователей.',
    buttons: {
      confirm: {
        label: 'Изменить владельца',
        className: 'btn-primary',
      },
    },
    callback,
  });
}

export function confirmImageForceRemoval(callback: ConfirmCallback) {
  confirm({
    title: 'Вы уверены?',
    message:
      'Принудительное удаление удалит образ, даже если у него несколько тегов или он используется остановленными контейнерами.',
    buttons: {
      confirm: {
        label: 'Удалить образ',
        className: 'btn-danger',
      },
    },
    callback,
  });
}

export function cancelRegistryRepositoryAction(callback: ConfirmCallback) {
  confirm({
    title: 'Вы уверены?',
    message:
      'Прерывание операции до её завершения приведет к потере всех тегов. Продолжить?',
    buttons: {
      confirm: {
        label: 'Остановить',
        className: 'btn-danger',
      },
    },
    callback,
  });
}

export function confirmDeletion(message: string, callback: ConfirmCallback) {
  const messageSanitized = sanitize(message);
  confirm({
    title: 'Вы уверены?',
    message: messageSanitized,
    buttons: {
      confirm: {
        label: 'Удалить',
        className: 'btn-danger',
      },
    },
    callback,
  });
}

export function confirmDetachment(message: string, callback: ConfirmCallback) {
  const messageSanitized = sanitize(message);
  confirm({
    title: 'Вы уверены?',
    message: messageSanitized,
    buttons: {
      confirm: {
        label: 'Отключить',
        className: 'btn-danger',
      },
    },
    callback,
  });
}

export function confirmDeassociate(callback: ConfirmCallback) {
  const message =
    '<p>De-associating this Edge environment will mark it as non associated and will clear the registered Edge ID.</p>' +
    '<p>Any agent started with the Edge key associated to this environment will be able to re-associate with this environment.</p>' +
    '<p>You can re-use the Edge ID and Edge key that you used to deploy the existing Edge agent to associate a new Edge device to this environment.</p>';
  confirm({
    title: 'Об отвязке окружения',
    message: sanitize(message),
    buttons: {
      confirm: {
        label: 'Отвязать',
        className: 'btn-primary',
      },
    },
    callback,
  });
}

export function confirmUpdate(message: string, callback: ConfirmCallback) {
  const messageSanitized = sanitize(message);

  confirm({
    title: 'Вы уверены?',
    message: messageSanitized,
    buttons: {
      confirm: {
        label: 'Обновить',
        className: 'btn-warning',
      },
    },
    callback,
  });
}

export function confirmRedeploy(message: string, callback: ConfirmCallback) {
  const messageSanitized = sanitize(message);

  confirm({
    title: '',
    message: messageSanitized,
    buttons: {
      confirm: {
        label: 'Развернуть приложения повторно',
        className: 'btn-primary',
      },
      cancel: {
        label: 'Сделать позже',
      },
    },
    callback,
  });
}

export function confirmDeletionAsync(message: string) {
  return new Promise((resolve) => {
    confirmDeletion(message, (confirmed) => resolve(confirmed));
  });
}

export function confirmEndpointSnapshot(callback: ConfirmCallback) {
  confirm({
    title: 'Вы уверены?',
    message:
      'Будет выполнен опрос всех окружений для обновления сведений. Это может занять некоторое время.',
    buttons: {
      confirm: {
        label: 'Продолжить',
        className: 'btn-primary',
      },
    },
    callback,
  });
}

export function confirmImageExport(callback: ConfirmCallback) {
  confirm({
    title: 'Внимание',
    message:
      'Экспорт может занять несколько минут. Не покидайте страницу до его завершения.',
    buttons: {
      confirm: {
        label: 'Продолжить',
        className: 'btn-primary',
      },
    },
    callback,
  });
}
